var AbstractDataModel = require("./AbstractDataModel")
var MessagesWS = require("../ws/MessagesWS");
var KioskMessagesWS = require("../ws/KioskMessagesWS");
var CustomScreensWS = require("../ws/CustomScreensWS");
var CheckPhoneEnabledWS = require("../ws/CheckPhoneEnabledWS");
var filterUnique = require("../helpers/operators").filterUnique
var getQueryParam = require("../helpers/viewmodels").getQueryParam

function LocationModel(obj) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractDataModel.apply(self, arguments);

  // Create a dummy ID
  self.id = -1;

  // Will hold a service
  self.checkPhoneEnabledWS = null;
  self.customScreensWS = null;
  self.customScreensCalled = false;
  self.supportsStationMetadata = null;

  self.removeFromAllWithoutConfirmation = false;

  if (obj) {
    // The JSON contains all we need
    self = Object.assign(self, obj);

    // Debugging
    if (getQueryParam('debug') === 'true') {
      self.data = obj;
    }

    // Ticket Classifiers are grouped in a collection called ticketClassifier, so make sure it's an array and assign it here.
    self.ticketClassifiers = Array.makeArray(obj.ticketClassifier);

    self.language = Array.isArray(obj.language) ?
                    filterUnique(self.language.map(self.convertToValidLanguage)) :
                    [ self.convertToValidLanguage(obj.language) ];

    // Custom Ticket Classifiers need to always be present as an array
    self.customTicketClassifierFields = Array.makeArray(obj.customTicketClassifierFields);

    // Set up this weird service to get a single property used in the classifiers interface
    self.checkPhoneEnabledWS = new CheckPhoneEnabledWS(self);
    self.phoneEnabledForKiosk = self.dependentObservable('phoneEnabled', self.checkPhoneEnabledWS);
    self.checkPhoneEnabledWS.doRequest();

    self.customScreensWS = new CustomScreensWS(self);
    self.kioskMessagesWS = new KioskMessagesWS(self);

    self.messagesWS = new MessagesWS(self);
    self.messagesWS.doRequest(null, self.id);

    // Ensure `supportsStationMetaData` invariant is truthy or false.
    // The Linebuster DB allows this to be `null`, `0` (false) or `1` (true) however `null` and `false` are treated
    // as false
    self.supportsStationMetadata = function () {
      return (obj.supportsStationMetadata ? true : false);
    };

  }


  // `customScreens` is an observable that fetches the data when it is first used/observed
  self.customScreens = ko.computed({
    "read": function () {
      if (!self.customScreens.loaded()) {
        self.customScreens.load();
      }
      return self.customScreens.value();
    },
    "write": function (value) {
      self.customScreens.value(value);
    },
    // This ensures that observable is not evaluated when it is defined.
    // Rather, only when it is used.
    "deferEvaluation": true,
  });

  // These keep the internal state the computed observable
  self.customScreens.loaded = ko.observable(false);
  self.customScreens.value = ko.observable([]);
  self.customScreens.load = function () {
    self.customScreensWS.doRequest(function () {
      self.customScreens(self.customScreensWS.allScreens());
      self.customScreens.loaded(true);
    });
    self.kioskMessagesWS.doRequest();
  };

  self.hasTicketClassifiers = function () {
    return self.ticketClassifiers.length > 0;
  }

  return self;
}

LocationModel.prototype = Object.create(AbstractDataModel.prototype);
LocationModel.prototype.constructor = LocationModel;

LocationModel.prototype.convertToValidLanguage = function (language) {
    return language && typeof language === 'string' ?  language : 'en';
}

module.exports = LocationModel
